module.exports = __webpack_public_path__ + "static/media/amex.f6262aa8.png";